module.exports = __webpack_public_path__ + "assets/img/73.c5766ed6.png";